
export class QuestionAnswerDto {

     answerId;
     textAnswer;
     answer;
     personCreating;
     creationDate;
     modPerson;
     modDate;
     relevantInPostControlNote;
     control;
     questionInBlock;
     attachments;
}


















